module.exports = __webpack_public_path__ + "static/logo-9f7d2e1467f1d05bd152f33ba2292a1d.png";